import { gethWxSignature } from '@/service/activity/brandWeek';
import wx from 'weixin-js-sdk';
import md5 from 'js-md5';
// import BrandWeekStore from '@/store/modules/brandWeek';
// import {  shareAction } from '@/service/activity/brandWeek'
export function wxShare (config) {
  // 判断是否为微信app内置的浏览器
  function isBHO() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.indexOf('qq') > 0 || ua.indexOf('weibo') > 0) {
      return true;
    } else {
      return false;
    }
  }
  const location = window.location.href;
  let fromApp = location.indexOf('fromApp')>-1;
  if (fromApp) {
    return;
  }
  const defaulConfig = {
    url: window.location.href.indexOf('#')>0? window.location.href.split('#')[0] : window.location.href,
    img: document.querySelector('meta[itemprop="image"]').getAttribute('content') || document.querySelector('img').currentSrc,
    title: document.querySelector('meta[itemprop="name"]').getAttribute('content') || document.title,
    desc: document.querySelector('meta[name="description"]').getAttribute('content') || document.querySelector('p').innerText
 };
 !config && (config = defaulConfig);
 !config.url && (config.url = defaulConfig.url);
 !config.img && (config.url = defaulConfig.img);
 !config.title && (config.url = defaulConfig.title);
 !config.desc && (config.url = defaulConfig.desc);
  let shareUrl = config.url || location,
      title = config.title,
      shareImg = config.img,
      summary = config.desc;
  var isQQ = isBHO();
  if (!isQQ) {
    return false;
  }
  qqShare(title, summary, shareUrl, shareImg);
  function qqShare(title, summary, shareUrl, shareImg) {
     var getDataSort = function(data) {
       var sdic = Object.keys(data).sort();
       var newData = '';
       for (var ki in sdic) {
         if (ki == sdic.length - 1) {
           var date = new Date();
           var month = date.getMonth() + 1;
           if (month < 10) {
             month = '0' + month;
           }
           var day = date.getDate();
           if (day < 10) {
             day = '0' + day;
           }
           var hours = date.getHours();
           if (hours < 10) {
             hours = '0' + hours;
           }
           var dateStr = date.getFullYear() + "-" + month + '-' + day + ' ' + hours;
           newData += (sdic[ki] + "=" + data[sdic[ki]] + "diandongbang.com" + dateStr);
         } else {
           newData += (sdic[ki] + "=" + data[sdic[ki]] + "&");
         }
       }
       return newData;
     };
     var obj = {};
     //获取签名需要 url（当前网页的URL，不包含#及其后面部分） 签名用的url必须是调用JS接口页面的完整URL
     obj.url = window.location.href.indexOf('#')>-1 ? window.location.href.split('#')[0] : window.location.href;
     var sign = getDataSort(obj);
     var data = {};
     data.url = obj.url;
     data.sign = md5(sign);
     gethWxSignature(data).then( res => {
       if (res.code == 200) {
         title = title.trim();
         wx.config({
           debug: false,
           appId: res.data.appId,
           timestamp: res.data.timestamp,
           nonceStr: res.data.nonceStr,
           signature: res.data.signature,
           jsApiList: [
             'checkJsApi',
             'updateAppMessageShareData',
             'updateTimelineShareData',
             'scanQRCode',
             'chooseWXPay'
           ]
         });
         window.wx = wx;
         wx.ready(function() {
           var shareData = {
             title: title, // 分享标题
             desc: summary, // 分享描述
             link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
             imgUrl: shareImg,  // 分享图标
              trigger: function(res) {
                console.log(res, '微信分享trigger触发');
                //alert('分享trigger');
                // if (BrandWeekStore.state.isShare!=1 && BrandWeekStore.state.userInfo &&  BrandWeekStore.state.userInfo.islogin) {
                //  //if ( BrandWeekStore.state.userInfo &&  BrandWeekStore.state.userInfo.islogin) {
                //     //登录 且未分享  
                //     alert('登录未分享')
                //     const data = {
                //       share_link: shareUrl
                //     }
                //     shareAction(data).then( res => {
                //       if (res.code == 200) {
                //         alert('分享异步请求成功')
                //         alert(JSON.stringify(res))
                //         BrandWeekStore.setLeftDrawTimes(res.data.left_times);
                //         BrandWeekStore.setIsShare(1);
                //       }
                //     })
                // }
              },
             success: function(res) {
              console.log(res)
             },
             cancel: function(res) {
              console.log(res)
             },
             fail: function(res) {
              console.log(res)
             }
           };
           // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
           wx.updateAppMessageShareData(shareData);
           // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
           wx.updateTimelineShareData(shareData);
         });
         wx.error(function(res) {
           console.log("error: " + res.errMsg);
         });
      }
    })
  }
 }
